import type { RefCallback } from 'react'
import { useMemo } from 'react'
import { useInView } from 'react-intersection-observer'

import { ChertoExperiments } from 'constants/experiments'
import useExperiment from 'hooks/Experiments/useExperiment'

interface ReviewsAboveLocationExperimentState {
  reviewsExperimentActivationRef: RefCallback<HTMLDivElement>
  showReviewsFirst: boolean
}

/**
 * Attach the activation ref to the footer's section tab bar. It sits at the top of the footer in
 * both arms and stays stuck on screen while any part of the footer is visible (including after
 * the rating badge jumps to the reviews section), so both arms join at the same moment.
 */
function useReviewsAboveLocationExperiment(hasEligibleReviews: boolean): ReviewsAboveLocationExperimentState {
  const [reviewsExperimentActivationRef, isFooterInView] = useInView({ triggerOnce: true })
  const experimentOptions = useMemo(() => ({
    canActivate: hasEligibleReviews && isFooterInView,
  }), [hasEligibleReviews, isFooterInView])
  const { isAnyVariant } = useExperiment(ChertoExperiments.croOfferPageReviewsAboveLocation, experimentOptions)

  return {
    reviewsExperimentActivationRef,
    showReviewsFirst: hasEligibleReviews && isAnyVariant,
  }
}

export default useReviewsAboveLocationExperiment
